module.exports = __webpack_public_path__ + "d13c7876a7ef4b8254de7995c7e15839.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/meta_2023_chart.png
// module id = 1695
// module chunks = 0